import { Outlet, Route, Routes } from "react-router";
import { TabBar } from "./components/TabBar";
import styles from "./routes.module.css";
import { CalendarScreen } from "./screens/CalendarScreen";
import { DayScreen } from "./screens/DayScreen";
import { NotFoundScreen } from "./screens/NotFoundScreen";
import { QuestionnaireScreen } from "./screens/QuestionnaireScreen";
import { ReportsScreen } from "./screens/ReportsScreen";
import { SettingsScreen } from "./screens/SettingsScreen";
import { StatsScreen } from "./screens/StatsScreen";
import { TodayScreen } from "./screens/TodayScreen";

export function TabLayout() {
  return (
    <div className={styles.layout}>
      <div className={styles.content}>
        <Outlet />
      </div>
      <TabBar />
    </div>
  );
}

export function AppRoutes() {
  return (
    <Routes>
      <Route element={<TabLayout />}>
        <Route index element={<TodayScreen />} />
        <Route path="calendar" element={<CalendarScreen />} />
        <Route path="reports" element={<ReportsScreen />} />
        <Route path="settings" element={<SettingsScreen />} />
      </Route>
      <Route path="answer/:subscriptionId/:date/:entryId?" element={<QuestionnaireScreen />} />
      <Route path="day/:date" element={<DayScreen />} />
      <Route path="stats" element={<StatsScreen />} />
      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
}
